export enum PROVIDER_TYPE {
	KVBO = 'KVBO',
	HCS = 'HCS',
	KVD = 'KVD',
	KTS = 'KTS',
	HEZ = 'HEZ',
	PORTMONE = 'PORTMONE',
	HOSTPAY = 'HOSTPAY',
	NAFTOGAS = 'NAFTOGAS',
	MEGOGO = 'MEGOGO',
}

export enum PROVIDER_ID {
	KVBO = 1,
	KVD,
	KTS,
	HCS,
}
